import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const VirtualHost: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        label={t('settings.billing.seance.virtual.title')}
        description={t('settings.billing.seance.virtual.description')}
        value={settings.restrictVirtualHostDepositPayment}
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.RESTRICT_VIRTUAL_HOST_DEPOSIT_PAYMENT,
            value: value ? '1' : '0',
          })
        }
        variant="secondary"
        emptyBg
      />
    </>
  );
};
